import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';


import * as actions from '../../actions/auth';



class Logout extends React.Component {

    constructor(props) {
        super(props);

    

       
    }

    componentDidMount() {
       
        setTimeout(function() {}, 10);
         

        
    }

   


    render() {

      let {authenticated, user} = this.props.auth;
      this.props.onClick();
       setTimeout(function() {
          window.location.reload();
       }, 200);
                          
     
      

        return (


               <h1> Estas Inactivo. </h1>
                

            
        );

    }
};

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth
    }
}

export default connect(mapStateToProps, actions)(Logout);


// WEBPACK FOOTER //
// ./src/views/signin/logout.js